import { get, set, del } from 'idb-keyval';
import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';

const IDB_KEY = 'napihami-query-cache';

/**
 * IndexedDB alapú persister a React Query cache-hez
 * A menü adatokat lokálisan tárolja a gyorsabb betöltés érdekében
 */
export function createIDBPersister(): Persister {
  return {
    persistClient: async (client: PersistedClient) => {
      try {
        await set(IDB_KEY, client);
      } catch (error) {
        console.warn('Failed to persist query cache:', error);
      }
    },
    restoreClient: async () => {
      try {
        return await get<PersistedClient>(IDB_KEY);
      } catch (error) {
        console.warn('Failed to restore query cache:', error);
        return undefined;
      }
    },
    removeClient: async () => {
      try {
        await del(IDB_KEY);
      } catch (error) {
        console.warn('Failed to remove query cache:', error);
      }
    },
  };
}
